import { createSelector } from "@reduxjs/toolkit";

const selectCommonSlicer = (state) => state.common;

/** Select header */
export const selectHeaderInfo = createSelector(
  [selectCommonSlicer],
  (common) => common.headerInfo
);